var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      ref: "elDropdown",
      attrs: {
        trigger: "click",
        "hide-on-click": false,
        placement: "bottom-start",
      },
      on: { "visible-change": _vm.visibleChange },
    },
    [
      _c(
        "div",
        { staticClass: "el-select", on: { click: _vm.packup } },
        [
          _vm.multiple
            ? _c(
                "div",
                {
                  ref: "tags",
                  staticClass: "el-select__tags",
                  style: {
                    "max-width": _vm.inputWidth - 32 + "px",
                    width: "100%",
                    zIndex: 9,
                  },
                },
                [
                  _vm.collapseTags && _vm.selected.length
                    ? _c(
                        "span",
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                closable: !_vm.selectDisabled,
                                size: _vm.collapseTagSize,
                                hit: _vm.selected[0].hitState,
                                type: "info",
                                "disable-transitions": "",
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.deleteTag($event, _vm.selected[0])
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "el-select__tags-text" },
                                [_vm._v(_vm._s(_vm.selected[0].currentLabel))]
                              ),
                            ]
                          ),
                          _vm.selected.length > 1
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    closable: false,
                                    size: _vm.collapseTagSize,
                                    type: "info",
                                    "disable-transitions": "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-select__tags-text" },
                                    [
                                      _vm._v(
                                        "+ " + _vm._s(_vm.selected.length - 1)
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.collapseTags
                    ? _c(
                        "transition-group",
                        { on: { "after-leave": _vm.resetInputHeight } },
                        _vm._l(_vm.selected, function (item) {
                          return _c(
                            "el-tag",
                            {
                              key: _vm.getValueKey(item),
                              attrs: {
                                closable: !_vm.selectDisabled,
                                size: _vm.collapseTagSize,
                                hit: item.hitState,
                                type: "info",
                                "disable-transitions": "",
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.deleteTag($event, item)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "el-select__tags-text" },
                                [_vm._v(_vm._s(item.currentLabel))]
                              ),
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.filterable
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.query,
                            expression: "query",
                          },
                        ],
                        ref: "input",
                        staticClass: "el-select__input ml-10",
                        class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
                        style: {
                          "flex-grow": "1",
                          width: _vm.inputLength + "px",
                          "max-width": _vm.inputWidth - 42 + "px",
                        },
                        attrs: {
                          type: "text",
                          disabled: _vm.selectDisabled,
                          autocomplete: _vm.autoComplete || _vm.autocomplete,
                        },
                        domProps: { value: _vm.query },
                        on: {
                          focus: _vm.handleFocus,
                          blur: function ($event) {
                            _vm.softFocus = false
                          },
                          keyup: _vm.managePlaceholder,
                          keydown: [
                            _vm.resetInputState,
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "down", 40, $event.key, [
                                  "Down",
                                  "ArrowDown",
                                ])
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.handleNavigate("next")
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "up", 38, $event.key, [
                                  "Up",
                                  "ArrowUp",
                                ])
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.handleNavigate("prev")
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.selectOption.apply(null, arguments)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape",
                                ])
                              ) {
                                return null
                              }
                              $event.stopPropagation()
                              $event.preventDefault()
                              _vm.visible = false
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "delete",
                                  [8, 46],
                                  $event.key,
                                  ["Backspace", "Delete", "Del"]
                                )
                              ) {
                                return null
                              }
                              return _vm.deletePrevTag.apply(null, arguments)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "tab",
                                  9,
                                  $event.key,
                                  "Tab"
                                )
                              ) {
                                return null
                              }
                              _vm.visible = false
                            },
                          ],
                          compositionstart: _vm.handleComposition,
                          compositionupdate: _vm.handleComposition,
                          compositionend: _vm.handleComposition,
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.query = $event.target.value
                            },
                            _vm.debouncedQueryChange,
                          ],
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c("el-input", {
            ref: "reference",
            attrs: {
              placeholder: _vm.currentPlaceholder,
              readonly: "",
              size: "large",
            },
            model: {
              value: _vm.selectedLabel,
              callback: function ($$v) {
                _vm.selectedLabel = $$v
              },
              expression: "selectedLabel",
            },
          }),
          _c("div", { staticClass: "control fx-none fx-p-center" }, [
            _c(
              "div",
              { class: ["packup", { "is-opened": _vm.isOpen }] },
              [
                _vm.$slots.hideBtn
                  ? _vm._t("hideBtn")
                  : _c("i", {
                      staticClass:
                        "el-select__caret el-input__icon el-icon-arrow-down",
                    }),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _c(
            "div",
            { staticClass: "my-dropdown" },
            [
              _vm.data.length
                ? _c(
                    "el-scrollbar",
                    {
                      ref: "scrollbar",
                      attrs: {
                        "wrap-class":
                          "scrollbar-wrapper scrollbar-wrapper-maxheight",
                      },
                    },
                    [
                      _c("el-tree", {
                        ref: "tree",
                        staticStyle: { "min-width": "200px" },
                        attrs: {
                          data: _vm.data,
                          props: _vm.config,
                          "show-checkbox": _vm.showCheckbox,
                          "check-strictly": _vm.checkStrictly,
                          nodeKey: _vm.nodeKey,
                          "expand-on-click-node": false,
                          "filter-node-method": _vm.filterNode,
                        },
                        on: { check: _vm.treeCheck },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        width: "200px",
                        "text-align": "center",
                        color: "#999",
                      },
                    },
                    [_vm._v("数据加载中")]
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }